import {createContext, useContext, useMemo} from 'react'
import type {ReactNode} from 'react'
import type {Services} from './types'
import type {StoreConfig} from './mock/mock-store'

export interface MockUser {
    id: string
    email: string
    name: string
    permissions: string[]
    roles: string[]
    impersonating: boolean
    originalUser: {name: string; email: string} | null
}

const ServicesContext = createContext<Services | null>(null)

export function useServices(): Services {
    const ctx = useContext(ServicesContext)
    if (!ctx) {
        throw new Error('useServices must be used within ServiceProvider')
    }
    return ctx
}

interface ServiceProviderProps {
    services: Services
    children: ReactNode
}

export function ServiceProvider({services, children}: ServiceProviderProps) {
    const value = useMemo(() => services, [services])
    return <ServicesContext.Provider value={value}>{children}</ServicesContext.Provider>
}

export interface MockStore {
    services: Services
    currentUser: MockUser
    reset(config?: StoreConfig): void
    setUser(user: Partial<MockUser>): void
    mockLogin(email: string): boolean
}

interface MockServiceProviderProps {
    store: MockStore
    children: ReactNode
}

export function MockServiceProvider({store, children}: MockServiceProviderProps) {
    return <ServicesContext.Provider value={store.services}>{children}</ServicesContext.Provider>
}
